import json from './sprite.js';

export default {
    handle: 'ENG_SPT8-Doctor_225002747',
    label: 'en_SPT8-Doctor_225002747',
    json,
};
